// Cal.com event slug for the "Book a call" flow, in the form `username/event`.
// Change this to match the event type you create in the Cal.com dashboard under
// the retiraapp@gmail.com account (see the booking setup notes).
export const CAL_LINK = 'retira/30min'
